import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import PipelineBuilder from "../pipeline-builder/PipelineBuilder";
import Button from "../Button";
import {Task} from "../../api/types";
import {agent} from "../../api/agent";
import styled from "styled-components";

interface Props {

}

const Container = styled.div`
    display: flex;
    justify-content: center;
    
    .content {
        min-width: 25rem;
        background-color: var(--content-box-bg);
        margin-top: 1rem;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
    
    .entry {
        font-size: 1.3rem;
        gap: 1rem;
        padding: 1rem;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        cursor: pointer;
        &:hover {
            background-color: var(--content-box-border);
        }
        
        display: grid;
        grid-template-columns: 1fr auto;
        
        .delete {
            color: var(--error-red, #ff4545);
            cursor: pointer;
        }
        
    }
`;

export default function TaskEditor({}: Props) {

    const [searchParameters, setSearchParameters] = useSearchParams();
    const [task, setTask] = useState<Task | undefined | null>(null);
    const [tasks, setTasks] = useState<Task[]>([]);
    const [ci, setCi] = useState<any>();

    useEffect(() => {
        agent.getTasks().then(setTasks);
    }, [task]);

    useEffect(() => {
        if (searchParameters.has('taskId')) {
            const taskId = searchParameters.get('taskId');
            if (taskId === 'new') {
                setTask(undefined);//something
                return;
            }
            if (taskId !== null) {
                agent.getTask(taskId!).then((task) => {
                    setTask(task);
                    console.log(task);
                });
            }
        }else{
            setTask(null);
        }
    }, [searchParameters]);

    return (
        <div>
            {task !== null && (
                <>
                    <PipelineBuilder mode={'task'} task={task} ci={setCi}></PipelineBuilder>
                    <div style={{ display: "flex", gap: '2rem', marginLeft: '6rem', marginTop: '1rem'}}>
                        <Button onClick={() => {
                            if (task) {
                                agent.putTask({
                                    name: ci.name,
                                    ci: JSON.stringify(ci.children),
                                    id: task.id,
                                }).then(() => {
                                    setSearchParameters({});
                                });
                            }else{
                                agent.postTask({
                                    name: ci.name,
                                    ci: JSON.stringify(ci.children),
                                    id: 'new',
                                }).then(() => {
                                    setSearchParameters({});
                                });
                            }
                        }}>Save</Button>
                        <Button onClick={() => {
                            setTask(null);
                            setSearchParameters({});
                        }} type={'red'}>Cancel</Button>
                    </div>
                </>
            )}
            {task === null && (
                <Container>
                    <div className={'content'}>
                        <div style={{padding: '.5rem'}}>
                            <Button onClick={() => {
                                setSearchParameters({taskId: 'new'});
                            }}>Create</Button>
                        </div>
                        <div>
                            {tasks.map((task, index) => (
                                <div className={'entry'} key={index} onClick={() => {
                                    setSearchParameters({taskId: task.id});
                                }}>
                                    <span>{task.name}</span>
                                    <div className={'delete'} onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        agent.deleteTask(task.id).then(() => {
                                            setTasks(tasks.filter(t => t.id !== task.id));
                                            if (searchParameters.get('taskId') === task.id) {
                                                setSearchParameters({});
                                            }
                                        })
                                    }}>
                                        <i className="fa-solid fa-trash-can"></i>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>
            )}
        </div>
    );
}